import React from "react";
import { graphql } from "gatsby"
import Block from "../../Block";

class UGBImageBox extends Block {
  render() {
    const { block } = this.props;
    // do nothing
    return <></>;
  }
}

class UGBImageBoxFactory {
  get type() {
    return "ugb/image-box";
  }

  create(props) {
    return <UGBImageBox {...props} />;
  }
}

export default UGBImageBoxFactory;
